export default __webpack_public_path__ + "static/media/ori.159efad4.png";